import addViewboxToSvg from "utils/addViewboxToSvg";
import stripSvgDataPrefix from "utils/stripSvgDataPrefix";

export default async function downloadSvgAndAddViewbox(logoUrl) {
  const imgRegex = /^\/img\/(.+)/;
  if (imgRegex.test(logoUrl)) {
    const regexResult = logoUrl.match(imgRegex);
    if (!regexResult) {
      throw new Error("invalid img file");
    }
    const imagePathWithoutImg = regexResult[1];
    const imageContent = await import(`img/${imagePathWithoutImg}`);

    return addViewboxToSvg(imageContent);
  }

  logoUrl = stripSvgDataPrefix(logoUrl);
  if (logoUrl.indexOf("<svg") > -1) {
    return logoUrl;
  }

  // Image was not from `/img/` so fetch it
  const fetchResponse = await fetch(logoUrl);

  if (!fetchResponse.ok) {
    throw new Error("Could not download logo");
  }

  return addViewboxToSvg(await fetchResponse.text());
}
